import React, {memo} from "react";
import {formikPropertyChanged, personCaughtKeyGenerator} from "./index";
import {useTranslation} from "react-i18next";
import FormSection from "../../../components/FormSection";
import useDialog from "../../../components/useDialog";
import PersonCaughtDialog from "./PersonCaughtDialog";
import Icon from "@mui/material/Icon";
import PersonCaught from "./PersonCaught";
import MDButton from "materialDashboard/components/MDButton";
import MDTypography from "materialDashboard/components/MDTypography";

const attributes = ['peopleCaught']

const PeopleCaught = memo(({formik, incidentRegistry, inputDisabled}) => {
    const {t} = useTranslation(['incidents']);
    const newPersonCaughtDialog = useDialog();
    const editPersonCaughtDialog = useDialog();
    const [personCaught, setPersonCaught] = React.useState({});

    const handleCreate = (person) => {
        const peopleCaught = formik.values?.peopleCaught ?? [];
        formik.setFieldValue('peopleCaught', [...peopleCaught, {...person, key: personCaughtKeyGenerator()}]);
        newPersonCaughtDialog.close();
    }

    const handleEdit = (person) => {
        setPersonCaught(person);
        editPersonCaughtDialog.open();
    }

    const handleUpdate = (person) => {
        const peopleCaught = formik.values?.peopleCaught ?? [];
        formik.setFieldValue('peopleCaught', peopleCaught.map((p => p.key === person.key ? person : p)));
        editPersonCaughtDialog.close();
    }

    const handleDelete = (person) => {
        const peopleCaught = formik.values?.peopleCaught ?? [];
        formik.setFieldValue('peopleCaught', peopleCaught.filter(p => p.key !== person.key));
    }

    return <FormSection title={t('incidentForm.peopleCaughtTitle')}
                        unStyledCollapse>
        <PersonCaughtDialog formik={formik}
                            isOpen={newPersonCaughtDialog.isOpen}
                            onClose={newPersonCaughtDialog.close}
                            onApply={handleCreate}
                            incidentRegistry={incidentRegistry}/>
        <PersonCaughtDialog formik={formik}
                            person={personCaught}
                            isOpen={editPersonCaughtDialog.isOpen}
                            onClose={editPersonCaughtDialog.close}
                            onApply={handleUpdate}
                            incidentRegistry={incidentRegistry}/>

        {
            !inputDisabled && <MDButton onClick={newPersonCaughtDialog.open} variant="outlined" color="info"
                                       sx={{width: 'fit-content', ml: 'auto', alignSelf: "end"}}>
                {t('incidentForm.peopleCaught.addPersonCaught')}
            </MDButton>
        }
        {
            formik.values.peopleCaught?.length > 0 ?
                formik.values.peopleCaught.map((person, index) => {
                    return <PersonCaught key={person.key}
                                         person={person}
                                         number={index + 1}
                                         incidentRegistry={incidentRegistry}
                                         onDelete={handleDelete}
                                         onEdit={() => handleEdit(person)}
                                         inputDisabled={inputDisabled}/>
                }) :
                <MDTypography variant="body2" color="secondary" textAlign='center'>
                    <Icon fontSize="large">inbox</Icon><br/>
                    {t('incidentForm.peopleCaught.noPeopleCaught')}
                </MDTypography>
        }
    </FormSection>

}, (prevProps, nextProps) => formikPropertyChanged(prevProps, nextProps, attributes))


export default PeopleCaught;